var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"small-btn bg-white mx-1",attrs:{"depressed":"","color":"primary","outlined":""},on:{"click":function($event){return _vm.SET_IS_DARKMODE(!_vm.isDarkMode)}}},[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("mdi-weather-"+_vm._s(_vm.isDarkMode ? 'night' : 'sunny'))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }